import React, { useState, useEffect, useCallback, useRef } from "react";
import lodashDebounce from "lodash/debounce";
import { TextField } from "@mui/material";
import { SLATE, INDIGO } from "../constants/Colors";

const HEX_INPUT_SX = {
  width: "120px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "0.875rem",
    bgcolor: "#ffffff",
    "& fieldset": { borderColor: SLATE[300] },
    "&:hover fieldset": { borderColor: SLATE[400] },
    "&.Mui-focused fieldset": { borderColor: INDIGO[500] },
  },
  "& .MuiInputBase-input": { color: SLATE[900] },
};

const ColorPicker = ({ label, name, value, onChange, onBlur }) => {
  const [internalValue, setInternalValue] = useState(value);
  const colorPickerOpen = useRef(false);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const debouncedOnBlur = useCallback(
    lodashDebounce((latestValue) => {
      if (onBlur) {
        onBlur({ target: { name, value: latestValue } });
      }
    }, 300),
    [onBlur, name]
  );

  const handleColorChange = (event) => {
    const newValue = event.target.value;
    setInternalValue(newValue);
    onChange({ target: { name, value: newValue } });
    if (!colorPickerOpen.current) {
      debouncedOnBlur(newValue);
    }
  };

  const handleTextChange = (event) => {
    const newValue = event.target.value;
    setInternalValue(newValue);
    onChange({ target: { name, value: newValue } });
    debouncedOnBlur(newValue);
  };

  const handleColorPickerOpen = () => { colorPickerOpen.current = true; };
  const handleColorPickerClose = () => {
    colorPickerOpen.current = false;
    debouncedOnBlur(internalValue);
  };

  return (
    <div className="flex-row flex-align-items-center" style={{ gap: "8px" }}>
        <TextField
          value={internalValue}
          onChange={handleTextChange}
          onBlur={() => debouncedOnBlur(internalValue)}
          size="small"
          placeholder="#000000"
          sx={HEX_INPUT_SX}
        />
        <div style={{ position: "relative", display: "inline-block" }}>
          <div
            style={{
              width: 24,
              height: 24,
              backgroundColor: internalValue,
              border: "1px solid " + SLATE[400],
              borderRadius: "4px",
              cursor: "pointer",
            }}
          />
          <input
            type="color"
            value={internalValue}
            onChange={handleColorChange}
            onFocus={handleColorPickerOpen}
            onBlur={handleColorPickerClose}
            aria-hidden="true"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: 24,
              height: 24,
              opacity: 0,
              cursor: "pointer",
            }}
          />
        </div>
      </div>
  );
};

export default ColorPicker;
